var intlTelInput = require('intl-tel-input');

/**
The individual object representing a single loss location.
This would be expanded upon to include multiple input elements
**/

var AssignmentContact = function(contName, contPhone, contEmail, contType){

    var editStr = 'Edit';
    if (window.Language == "spanish")
    {
        editStr = 'Editar';
    }

    this.$el = $('<div class="assign-cont column small-10 medium-9 large-7"><div class="form-item"><div class="remove-btn"></div><span class="assign-cont-text"></span><div class="edit-btn">' + editStr + '</div></div></div>');
    this.$el.find('.assign-cont-text').text(contName);

    this.contName = contName;
    this.contPhone = contPhone;
    this.contEmail = contEmail;
    this.contType = contType;

};

// adding the elements to the dom
AssignmentContact.prototype.addToDOM = function(){

    $("#assign-conts-wrap").append(this.$el);

};

// removing the elements from the dom
AssignmentContact.prototype.removeFromDOM = function(){

    this.$el.remove();

};

// update the loss location
AssignmentContact.prototype.update = function(contName, contPhone, contEmail, contType){

    var editStr = 'Edit';
    if (window.Language == "spanish")
    {
        editStr = 'Editar';
    }

    var $updatedEl = $('<div class="assign-cont column small-10 medium-9 large-7"><div class="form-item"><div class="remove-btn"></div><span class="assign-cont-text"></span><div class="edit-btn">' + editStr + '</div></div></div>');
    $updatedEl.find('.assign-cont-text').text(contName);

    // replace the element in the dom
    this.$el.replaceWith($updatedEl);

    // point this object to the updated element
    this.$el = $updatedEl;

    // update this objects variables
    this.contName = contName;
    this.contPhone = contPhone;
    this.contEmail = contEmail;
    this.contType = contType;

};

// this updates the form fields associated with this loss location
/*
AssignmentContact.prototype.updateFormFields = function(assignContId){
    var assignContFieldId = assignContId + 1; // form fields are 1 indexed

    $('#assign-conts-name-' + assignContFieldId).val(this.contName);
    $('#assign-conts-cell-phone-' + assignContFieldId).val(this.contCell);
    $('#assign-conts-phone-' + assignContFieldId).val(this.contPhone);
    $('#assign-conts-email-' + assignContFieldId).val(this.contEmail);
    $('#assign-conts-type-' + assignContFieldId).val(this.contType);

};
*/

// updating the id of the loss location, based on the total number of active loss locations
// inside the DOM
AssignmentContact.prototype.updateId = function(index){
    this.$el.attr("data-assign-cont-id", index);
};

AssignmentContact.prototype.getName = function(){
    return this.contName;
};

AssignmentContact.prototype.getPhone = function(){
    return this.contPhone;
};

AssignmentContact.prototype.getEmail = function(){
    return this.contEmail;
};

AssignmentContact.prototype.getType = function(){
    return this.contType;
};






/**
A controller object that handles the macro-level interactions
for Loss Locations field itself. This is what show/hides the modal
and creates individual AssignmentContact objects, which get added/removed
from the DOM
**/
var AssignmentContactController = function(){

    var self = this;

    // a property to hold all our active loss locations
    this.assignConts = [];

    // set the modal for use later
    this.$modal = $('#assign-conts-modal');

    // variable to keep track of if we're editing or not when the modal is open
    this.isEditingId = -1;

    // get our modal fields
    this.$fieldName   = $('#assign-cont-name');
    this.$fieldPhone  = $('#assign-cont-phone');
    this.$fieldEmail  = $('#assign-cont-email');
    this.$fieldType   = $('#assign-cont-type');

    // event handler to add a location
    $("#add-assign-cont").click(function(){
        self.isEditingId = -1;
        assignContFormValidator.resetForm();
        self.showModal();
    });

    // event handler to hide the modal
    $('#assign-conts-modal .close').click(function(){
        self.hideModal();
    });

    // event handler for when modal is submitted
    $('#submit-assign-cont').click(function(){

        //console.log($('#add-assign-cont-form').valid());

        $('#add-assign-cont-form').validate();
        self.validatePhoneField();
        if(!$('#add-assign-cont-form').valid() || (!self.validatePhoneField()))
        {
            return;
        }

        self.submit(self.isEditingId);

        /*
        if (self.assignConts.length >= 5)
        {
            $('#add-assign-cont').hide();
        }
        */

    });

    // We're binding this event onto the body, so any
    // loss locations created "in the future" will be handled
    // from this method. We're doing it here, rather than in the
    // Loss Location object so we have access to the this.lossLocations
    // array. -- This is a little janky, but oh well..
    $("#assign-conts-wrap").on("click", ".remove-btn", function(e){
        e.preventDefault();
        self.remove(this);

        /*
        if (self.assignConts.length < 5)
        {
            $('#add-assign-cont').show();
        }
        */
    });

    // edit buttons
    $('#assign-conts-wrap').on("click", ".edit-btn", function(e){
        e.preventDefault();
        // get the ID of the loss location being edited
        var $el = $(this);
        var assignContId = Number($el.parents('.assign-cont').data("assign-cont-id"));
        self.isEditingId = assignContId;
        self.showModal(assignContId);
    });

    var assignContFormValidator = $('#add-assign-cont-form').validate({
        rules: {
            "assign-cont-name": {
                required: true
            },
            "assign-cont-email": {
                required: true,
                email: true
            },
            "assign-cont-type": {
                required: true
            }
        },
        errorPlacement: function(error, element) {
            if (element.attr("type") == "text") {
                error.appendTo( element.closest("div.field") );
            }
            else {
                error.appendTo( element.closest("div") );
            }
        }
    });

    this.$fieldPhone.on('blur', function() {
        self.validatePhoneField();
    });

    this.$fieldPhone.on('keyup', function() {
        self.validatePhoneField();
    });


};

AssignmentContactController.prototype.submit = function(assignContId){

    // get phone number
    var iti = window.intlTelInputGlobals.getInstance(this.$fieldPhone[0]);
    var phoneNumber = iti.getNumber();

    if (assignContId == -1)
    {
        this.add(
            this.$fieldName.val(),
            phoneNumber,
            this.$fieldEmail.val(),
            this.$fieldType.val()
        );
    }
    else
    {
console.log('editing: ' + assignContId);
        this.updateLocation(
            assignContId,
            this.$fieldName.val(),
            phoneNumber,
            this.$fieldEmail.val(),
            this.$fieldType.val()
        );
    }

    this.hideModal();
};

AssignmentContactController.prototype.validatePhoneField = function(){

    var self = this;
    var iti = window.intlTelInputGlobals.getInstance(self.$fieldPhone[0]);
    var isValid = iti.isValidNumber();

    var errorMap = ["Invalid number.", "Invalid country code.", "Too short.", "Too long.", "Invalid number."];

    // remove any existing error messages from the field
    self.clearPhoneFieldErrors();

    if (!self.$fieldPhone.val().trim())
    {
        var returnMsg = "This field is required.";
    }
    else if (!isValid)
    {
        var errorCode = iti.getValidationError();
        var returnMsg = errorMap[errorCode];
    }
    else
    {
        return true;
    }

    // create our error label
    var $errorLabel = $('<label>').addClass('error-label').attr('for', self.$fieldPhone.attr('id')).attr('id', self.$fieldPhone.attr('id') + '-error').text(returnMsg);
    // add the error to the DOM
    self.$fieldPhone.closest('[data-form-field-phone]').append($errorLabel);

    return false;

};

AssignmentContactController.prototype.clearPhoneFieldErrors = function(){

    this.$fieldPhone.closest('[data-form-field-phone]').find('label.error-label').remove();

};

AssignmentContactController.prototype.showModal = function(assignContId = -1){

    this.updateModalFields(assignContId);
    this.clearPhoneFieldErrors();

    if (window.matchMedia("(max-width: 480px)").matches) {
      $('body').addClass('fixed-body'); // adding this class fixes a bug in iOS 11 safari
    }

    $('.modal-wrap').css('display', 'flex');
    this.$modal.show();
    this.$modal.fadeTo(10, 1);
    $('.modal-overlay').show();
    $('.modal-overlay').fadeTo(10, 1);

};

AssignmentContactController.prototype.updateModalFields = function(assignContId){

    var self = this;

    var iti = window.intlTelInputGlobals.getInstance(self.$fieldPhone[0]);

    if (assignContId == -1)
    {
        // adding new location, clear fields
        $('#assign-conts-modal').find('input:text').val('');

        // clear phone field and set country back to default
        this.$fieldPhone.val('');
        iti.setCountry('us');
    }
    else
    {
        // editing location, fill in fields
        var assignCont = this.assignConts[assignContId];

        this.$fieldName.val(assignCont.getName());
        //this.$fieldPhone.val(assignCont.getPhone());
        this.$fieldEmail.val(assignCont.getEmail());
        this.$fieldType.val(assignCont.getType());

        // phone field
        iti.setNumber(assignCont.getPhone());

    }
};

AssignmentContactController.prototype.hideModal = function(){

    $('body').removeClass('fixed-body');
    if (window.matchMedia("(max-width: 480px)").matches) {
        $(window).scrollTop( $('#assign-conts-section').offset().top ); // scroll back, because adding fixed scrolls to top
    }

    this.$modal.hide();
    $('.modal-wrap').css('display', 'none');
    this.$modal.css('opacity', '0');
    $('.modal-overlay').hide();
    $('.modal-overlay').css('opacity', '0');
};

// where we create individual Assignment Contacts, and add them
// into the assignConts array
AssignmentContactController.prototype.add = function(contName, contPhone, contEmail, contType){

console.log('add: ' + contName);

    var assignCont = new AssignmentContact(contName, contPhone, contEmail, contType);
    assignCont.addToDOM();
    this.assignConts.push(assignCont);
    this.updateLocationIds();
    this.updateLocationFormFields();

};

// where we remove invidual assignment contacts from the DOM
AssignmentContactController.prototype.remove = function(el){

    var $el = $(el);
    var assignContId = Number($el.parents('.assign-cont').data("assign-cont-id"));
    this.assignConts[assignContId].removeFromDOM();
    this.assignConts.splice(assignContId, 1);
    this.updateLocationIds();
    this.updateLocationFormFields();

};

// this updates an existing loss location
AssignmentContactController.prototype.updateLocation = function(assignContId, contName, contPhone, contEmail, contType){
    this.assignConts[assignContId].update(contName, contPhone, contEmail, contType);
    this.updateLocationIds();
    this.updateLocationFormFields();
};

// after we add or remove from the DOM we need to update IDs
// to refect the new organization of the active arrays
AssignmentContactController.prototype.updateLocationIds = function(){
    $('.js-assign-conts-field').val('');
    $.each(this.assignConts, function(index){
        var assignCont = this;
        assignCont.updateId(index);
    });

}

// this function updates the form fields associated with each loss location
AssignmentContactController.prototype.updateLocationFormFields = function(){
    /*
    $.each(this.assignConts, function(index){
        var assignCont = this;
        assignCont.updateFormFields(index);
    });
    */

    // get our assignment contacts input wrapper
    var $assignContsFieldWrap = $('#assign-conts-table-fields-wrapper');

    // clear our assignment contact form fields out
    $assignContsFieldWrap.html('');

    // go through this.assignConts and add table inputs for each location
    $.each(this.assignConts, function(index){

        var assignCont = this;
        var assignContFieldId = index + 1; // form fields are 1-indexed

        // contact's name
        $('<input type="text" />')
            .attr('name', 'fields[assignmentContacts][' + assignContFieldId +'][contactsName]')
            .val(assignCont.contName)
            .appendTo($assignContsFieldWrap);

        // contact's phone
        $('<input type="text" />')
            .attr('name', 'fields[assignmentContacts][' + assignContFieldId +'][contactsPhone]')
            .val(assignCont.contPhone)
            .appendTo($assignContsFieldWrap);

        // contact type
        $('<input type="text" />')
            .attr('name', 'fields[assignmentContacts][' + assignContFieldId +'][contactType]')
            .val(assignCont.contType)
            .appendTo($assignContsFieldWrap);

        // contact email
        $('<input type="text" />')
            .attr('name', 'fields[assignmentContacts][' + assignContFieldId +'][contactsEmail]')
            .val(assignCont.contEmail)
            .appendTo($assignContsFieldWrap);

    });

};

export default  AssignmentContactController;
